export var ONEPASS_SHOP_TILES_PER_ROW = 3;
export var ONEPASS_SHOP_FULL_WIDTH_TILES = ["catchAppBanner", "recentlyViewedProducts"];
export var SHOP_PAGE_PRODUCT_RECOMMENDER_LIMIT = 20;
export var SHOP_PRODUCTS_RECOMMENDER_MIN_COUNT = 5;
export var SHOP_PAGE_RECOMMENDER_TRENDING_PRODUCTS_CATEGORY = "club_catch";
export var SHOP_PAGE_RECOMMENDER_BEST_SELLER_PRODUCTS_CATEGORY = 69;